import { api } from "..";

const endpoint = "/api/operation-processes";

export const getOperationProcessList = (qp) => {
  return api.get(`${endpoint}/`, { params: qp });
};

export const getOperationProcessById = (id) => {
  return api.get(`${endpoint}/${id}`);
};

export const addOperationProcess = (data) => {
  return api.post(`${endpoint}/`, data);
};

export const updateOperationProcess = (id, data) => {
  return api.put(`${endpoint}/${id}`, data);
};

export const deleteOperationProcess = (id) => {
  return api.delete(`${endpoint}/${id}`);
};

export const getCPOOperationStatus = (cpoId) => {
  return api.get(`/api/client-purchase-orders/${cpoId}/operation-status`);
};

export const updateCPOOperationStatus = (cpoId, data) => {
  return api.put(`/api/client-purchase-orders/${cpoId}/operation-status`, data);
};
